import React from "react";
import Landing from "../pages/Landing";
import Contacts from "../pages/Contacts";
import Users from "../pages/Users";
import StandardApi from "../pages/StandardApi";
import InternalApi from "../pages/InternalApi";
import StreamingApi from "../pages/StreamingApi";
import Attachments from "../pages/Attachments";
import ContentVersion from "../pages/ContentVersion";
import SobjectApi from "../pages/SobjectApi";
import UIApi from "../pages/UIApi";
import Jsforce from "../pages/Jsforce";
import Settings from "../pages/Settings";
import PdfFiles from "../pages/PdfFiles";
import { CloudPremisePluginRoute } from "@cloudpremise/portal_core";

const routes = ({history, page, basename}): CloudPremisePluginRoute[] => {
    return [
        {
            route: "/all",
            component: (
                <Landing history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/contacts",
            component: (
                <Contacts history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/users",
            component: (
                <Users history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/standard-api",
            component: (
                <StandardApi history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/internal-api",
            component: (
                <InternalApi history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/streaming",
            component: (
                <StreamingApi />
            ),
            privacy: "private",
        },
        {
            route: "/all/attachments",
            component: (
                <Attachments history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/content-version",
            component: (
                <ContentVersion history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/sobject-api",
            component: (
                <SobjectApi history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/uiapi",
            component: (
                <UIApi history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/jsforce",
            component: (
                <Jsforce history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/settings",
            component: (
                <Settings history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/all/pdf",
            component: (
                <PdfFiles history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
    ]
};

export default routes;